import { Button, Col, Icon, Row, Tooltip, Typography } from 'antd'
import { DrawerProps } from 'antd/lib/drawer'
import _ from 'lodash'
import React from 'react'
import ReactJson from 'react-json-view'
import { Drawer } from '../drawer'

export type TDrawerViewJSON = {
  title?: string
  data: any
  visible?: boolean
  onClose?: () => void
  displayDataTypes?: boolean
  drawerProps?: DrawerProps
}

const DrawerViewJSON = (props: TDrawerViewJSON) => {

  return (
    <Drawer
      title={<Row type='flex' align='middle' justify='space-between' style={{ whiteSpace: 'nowrap' }}>
        <Col style={{ flex: 1, minWidth: 0, gap: 2, display: 'flex', alignItems: 'center' }}>
          <Icon type='left' className="hover-primary mr10 mb2" onClick={props.onClose} />
          <Tooltip placement='bottom' title={props.title}>
            <Typography.Text ellipsis className='txt-black-color-80'
              style={{
                fontSize: 16, overflow: 'hidden',
                whiteSpace: 'nowrap', textOverflow: 'ellipsis'
              }}>
              {props.title ? `View Json / ${props.title}` : 'View Json'}
            </Typography.Text>
          </Tooltip>
        </Col>

        <Col style={{ flexShrink: 0 }}>
          <Icon type='close' className="hover-primary txt-black-color-95" onClick={props.onClose} />
        </Col>
      </Row>}
      bodyStyle={{ padding: 0 }}
      visible={props.visible}
      onClose={props.onClose}
      width={700}
      zIndex={1002}
      destroyOnClose
      keyboard={true}
      maskClosable={true}
      {...props?.drawerProps}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          maxHeight: 'calc(100vh - 121px)',
          height: '100vh',
          overflow: 'auto',
          padding: '18px 24px',
          wordBreak: 'break-all'
        }}
      >
        <ReactJson displayDataTypes={_.isBoolean(props.displayDataTypes) ? props.displayDataTypes : false} src={props.data || {}} />
      </div>
      <div
        style={{
          borderTop: "1px solid #e9e9e9",
          padding: "10px 16px",
          background: "#fff",
          display: 'flex',
          justifyContent: 'flex-end',
          gap: 10,
        }}
      >
        <Button onClick={props.onClose}>Close</Button>
      </div>
    </Drawer >
  )
}

export default DrawerViewJSON
